var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.WaitMessage, { attrs: { ob: _setup.claimob } }),
      _vm._v(" "),
      !_setup.claimob.wait && !_setup.claimob.message
        ? _c(
            "div",
            [
              _setup.isBefore(_setup.claimob.status)
                ? [
                    _c("h2", [
                      _c("b", [_vm._v(_vm._s(_setup.claimob.status.name))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _setup.claimob.reward.is
                        ? _c("div", [
                            _vm._v("Начислено вознаграждение - "),
                            _c("b", [
                              _vm._v(_vm._s(_setup.claimob.reward.sum) + "р"),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _setup.claimob.status.detail
                      ? _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_setup.claimob.status.detail),
                          },
                        })
                      : _vm._e(),
                  ]
                : _setup.isShould(_setup.claimob.status)
                ? [
                    _setup.claimob.access.allow
                      ? [
                          _c(_setup.FinishClaim, {
                            attrs: {
                              claim: _setup.claimob.claim,
                              status: _setup.claimob.status,
                              reward: _setup.claimob.reward,
                            },
                          }),
                        ]
                      : [
                          _c("h2", {
                            domProps: {
                              textContent: _vm._s(_setup.claimob.access.whynot),
                            },
                          }),
                        ],
                  ]
                : _setup.isReady(_setup.claimob.status)
                ? [
                    _setup.claimob.access.allow
                      ? [
                          _c(_setup.StartWdr, {
                            attrs: { claim_num: _setup.claimob.claim.num },
                          }),
                        ]
                      : [
                          _c("h2", {
                            domProps: {
                              textContent: _vm._s(_setup.claimob.access.whynot),
                            },
                          }),
                        ],
                  ]
                : _setup.isActive(_setup.claimob.status)
                ? [
                    _c(_setup.RewardShow, {
                      attrs: {
                        claim: _setup.claimob.claim,
                        status: _setup.claimob.status,
                        actreward: _setup.claimob.actreward,
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }